import type React from 'react';

export function CtaScheduling(): React.ReactElement {
  return (
    <section className="py-16 px-4 bg-gray-900">
      <div className="max-w-7xl mx-auto text-center">
        {/* Main CTA Text */}
        <div className="mb-8">
          <p className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-6">
            Schedule your aircraft<br />for service
          </p>
        </div>
        
        {/* Phone CTA Button */}
        <div>
          <a
            href="tel:8507450422"
            className="inline-block px-8 py-4 bg-[#3aeb26] text-black font-bold text-xl rounded-lg hover:bg-green-400 transition-colors duration-300 shadow-lg"
          >
            850-745-0422
          </a>
        </div>
      </div>
    </section>
  );
}